(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9549],{

/***/ 13841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clientOptions": function() { return /* binding */ clientOptions; },
/* harmony export */   "getUserProfile": function() { return /* binding */ getUserProfile; },
/* harmony export */   "getUserTK": function() { return /* binding */ getUserTK; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72730);
/* harmony import */ var _utils_pages__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59837);
/* harmony import */ var _xo_union_sdk_membership__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66239);
/* harmony import */ var node_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59036);
/* harmony import */ var node_fetch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(node_fetch__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var process = __webpack_require__(37082);





var TkMembershipApiVersion = "v2";
var clientOptions = {
    env: "production",
    host: "https://membership-api.theknot.com",
    apiKey: "bb0d4ad40696c6f5b623efef5f3cea5c",
    version: TkMembershipApiVersion
};
var membershipServiceClient = new _xo_union_sdk_membership__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP({
    clientOptions: clientOptions
});
/* harmony default export */ __webpack_exports__["default"] = (membershipServiceClient);
var getUserTK = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(cookie) {
        var path, token, headers, response, user, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    path = "".concat("https://membership-api.theknot.com", "/members?apikey=").concat("bb0d4ad40696c6f5b623efef5f3cea5c");
                    token = (0,_utils_pages__WEBPACK_IMPORTED_MODULE_4__.parseXOMembershipToken)(cookie || "");
                    if (!token) return [
                        2,
                        null
                    ];
                    headers = new node_fetch__WEBPACK_IMPORTED_MODULE_0__.Headers();
                    headers.append("Accept-Version", TkMembershipApiVersion);
                    headers.append("Content-Type", "application/json");
                    headers.append("MEMBERSHIP-SESSION-TOKEN", token);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        node_fetch__WEBPACK_IMPORTED_MODULE_0___default()(path, {
                            headers: headers
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    user = _state.sent();
                    return [
                        2,
                        {
                            id: user.members.id,
                            username: "",
                            email: user.members.email,
                            firstName: "",
                            lastName: "",
                            avatar: {
                                url: "",
                                color: ""
                            },
                            unreadMessagesCount: "0"
                        }
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function getUserTK(cookie) {
        return _ref.apply(this, arguments);
    };
}();
function getUserWW(context) {
    return _getUserWW.apply(this, arguments);
}
function _getUserWW() {
    _getUserWW = _async_to_generator(function(context) {
        var _req, cookies, headers, uc, userId, userTipo, accessToken, refreshToken, ua, apiToken, sessionCookie, userResponse, user, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _req = context.req, cookies = _req.cookies, headers = _req.headers;
                    uc = cookies.UC, userId = cookies.USER_ID, userTipo = cookies.USER_TIPO, accessToken = cookies["tkww-access-token"], refreshToken = cookies["tkww-refresh-token"];
                    ua = headers["user-agent"] || headers["User-Agent"];
                    apiToken = String(process.env.BP_API_TOKEN);
                    sessionCookie = "";
                    if (uc !== null) sessionCookie += "UC=".concat(uc, ";");
                    if (userId !== null) sessionCookie += "USER_ID=".concat(userId, ";");
                    if (userTipo !== null) sessionCookie += "USER_TIPO=".concat(userTipo, ";");
                    if (accessToken !== null) sessionCookie += "tkww-access-token=".concat(accessToken, ";");
                    if (refreshToken !== null) sessionCookie += "tkww-refresh-token=".concat(refreshToken, ";");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch("".concat(process.env.AUTH_API_BASE, "/userprofile/v1/user?fields=id,email,username,first_name,last_name,avatar,num_unread_msgs"), {
                            headers: {
                                "x-app-partner-key": apiToken,
                                "x-app-session-cookie": sessionCookie,
                                "x-app-user-agent": ua
                            }
                        })
                    ];
                case 2:
                    userResponse = _state.sent();
                    if (!userResponse.ok) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        userResponse.json()
                    ];
                case 3:
                    user = _state.sent();
                    return [
                        2,
                        {
                            id: user.id,
                            username: user.username,
                            email: user.email,
                            firstName: user.first_name,
                            lastName: user.last_name,
                            avatar: {
                                url: user.avatar.img,
                                color: user.avatar.color
                            },
                            unreadMessagesCount: user.num_unread_msgs
                        }
                    ];
                case 4:
                    return [
                        2,
                        null
                    ];
                case 5:
                    e = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _getUserWW.apply(this, arguments);
}
function getUserProfile(context) {
    return _getUserProfile.apply(this, arguments);
}
function _getUserProfile() {
    _getUserProfile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(context) {
        var ref, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                 false ? 0 : getUserTK((context === null || context === void 0 ? void 0 : (ref = context.req) === null || ref === void 0 ? void 0 : (ref1 = ref.headers) === null || ref1 === void 0 ? void 0 : ref1.cookie) || "")
            ];
        });
    });
    return _getUserProfile.apply(this, arguments);
}


/***/ }),

/***/ 53952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(45371);

module.exports = parent;


/***/ }),

/***/ 26992:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(17408);

module.exports = parent;


/***/ }),

/***/ 83902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(47590);

module.exports = parent;


/***/ }),

/***/ 18733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(2540);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').map;


/***/ }),

/***/ 63932:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(20829);

module.exports = __webpack_require__(41614);


/***/ }),

/***/ 30428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(18733);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.map;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.map) ? method : own;
};


/***/ }),

/***/ 47178:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89251);


/***/ }),

/***/ 4002:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(94878);


/***/ }),

/***/ 85220:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(40861);


/***/ }),

/***/ 89251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// TODO: remove from `core-js@4`
__webpack_require__(24180);

var parent = __webpack_require__(53952);

module.exports = parent;


/***/ }),

/***/ 94878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(26992);

module.exports = parent;


/***/ }),

/***/ 40861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(83902);

module.exports = parent;


/***/ }),

/***/ 85968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(68887);
var definePropertyModule = __webpack_require__(54926);
var createPropertyDescriptor = __webpack_require__(54007);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 1748:
/***/ (function(module) {

/* global Bun -- Deno case */
module.exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';


/***/ }),

/***/ 6087:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(41614);
var apply = __webpack_require__(5043);
var isCallable = __webpack_require__(64960);
var ENGINE_IS_BUN = __webpack_require__(1748);
var USER_AGENT = __webpack_require__(82182);
var arraySlice = __webpack_require__(59497);
var validateArgumentsLength = __webpack_require__(48894);

var Function = global.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && (function () {
  var version = global.Bun.version.split('.');
  return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
})();

// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function (scheduler, hasTimeArg) {
  var firstParamIndex = hasTimeArg ? 2 : 1;
  return WRAP ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
    var fn = isCallable(handler) ? handler : Function(handler);
    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
    var callback = boundArgs ? function () {
      apply(fn, this, params);
    } : fn;
    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
  } : scheduler;
};


/***/ }),

/***/ 48894:
/***/ (function(module) {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 48445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var fails = __webpack_require__(19699);
var isArray = __webpack_require__(79851);
var isObject = __webpack_require__(49949);
var toObject = __webpack_require__(77020);
var lengthOfArrayLike = __webpack_require__(48368);
var doesNotExceedSafeInteger = __webpack_require__(39676);
var createProperty = __webpack_require__(85968);
var arraySpeciesCreate = __webpack_require__(93201);
var arrayMethodHasSpeciesSupport = __webpack_require__(11095);
var wellKnownSymbol = __webpack_require__(81132);
var V8_VERSION = __webpack_require__(59483);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 2540:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var $map = (__webpack_require__(16918).map);
var arrayMethodHasSpeciesSupport = __webpack_require__(11095);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 20829:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var global = __webpack_require__(41614);

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true, forced: global.globalThis !== global }, {
  globalThis: global
});


/***/ }),

/***/ 24180:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
__webpack_require__(20829);


/***/ }),

/***/ 72599:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var global = __webpack_require__(41614);
var schedulersFix = __webpack_require__(6087);

var setInterval = schedulersFix(global.setInterval, true);

// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$({ global: true, bind: true, forced: global.setInterval !== setInterval }, {
  setInterval: setInterval
});


/***/ }),

/***/ 54738:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var global = __webpack_require__(41614);
var schedulersFix = __webpack_require__(6087);

var setTimeout = schedulersFix(global.setTimeout, true);

// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$({ global: true, bind: true, forced: global.setTimeout !== setTimeout }, {
  setTimeout: setTimeout
});


/***/ }),

/***/ 44362:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(72599);
__webpack_require__(54738);


/***/ }),

/***/ 45371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(63932);

module.exports = parent;


/***/ }),

/***/ 17408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(30428);

module.exports = parent;


/***/ }),

/***/ 47590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(44362);
var path = __webpack_require__(3999);

module.exports = path.setTimeout;


/***/ }),

/***/ 21818:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 26111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(47178);

/***/ }),

/***/ 93726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(4002);

/***/ }),

/***/ 79021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(85220);

/***/ })

}]);